import { activePort, ensureSnapshot } from '@/data/StorageRegistry';
import { DataSnapshot } from '@/types/domain';

export const DataService = {
  async getOrInit(seed: DataSnapshot) {
    return ensureSnapshot(seed);
  },
  async save(snapshot: DataSnapshot) {
    await activePort().put(snapshot);
  },
};
